export default __webpack_public_path__ + "static/magnesis-9d8765da5e6ba72f0ddbbd2c7f929d26.png";